import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/admin/stores/auth";
import { portalRequiresAuth } from "@/lib/portalAuth";

export function PortalProtectedRoute() {
  const { user, initialized, bootstrap } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (!portalRequiresAuth) {
    return <Outlet />;
  }

  if (!initialized) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-slate-500">
        Verificando acesso...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  }

  if (user.role === "cliente") {
    return <Navigate to={`${import.meta.env.VITE_ADMIN_PANEL_PATH || "/g7-painel-x9k"}/client`} replace />;
  }

  return <Outlet />;
}
